import { render, staticRenderFns } from "./InfoPopover.vue?vue&type=template&id=4f87e454"
import script from "./InfoPopover.vue?vue&type=script&lang=js"
export * from "./InfoPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports